// 真人客服帳號（handoff agents）— 與 members（子帳號）不同：
// 這是登入「Qubby 客服台」Chrome extension 接手 AI 轉真人的帳號。
import { api, get, post, del } from './client.js';

const path = (hostId, suffix = '') =>
    `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/agents${suffix}`;

export const serviceAgentsApi = {
    list: (hostId) => get(path(hostId)),
    create: (hostId, body) => post(path(hostId), body),
    update: (hostId, uid, body) =>
        api('PATCH', path(hostId, `/${encodeURIComponent(uid)}`), { body }),
    remove: (hostId, uid) => del(path(hostId, `/${encodeURIComponent(uid)}`)),
    resetPassword: (hostId, uid) =>
        post(path(hostId, `/${encodeURIComponent(uid)}/reset-password`), {}),
    // 頭像（LINE 接手時專員訊息的 sender icon）；imageBase64 = 前端裁好的 256×256 PNG dataURL
    uploadAvatar: (hostId, uid, imageBase64) =>
        post(path(hostId, `/${encodeURIComponent(uid)}/avatar`), { imageBase64 }),
    removeAvatar: (hostId, uid) =>
        del(path(hostId, `/${encodeURIComponent(uid)}/avatar`)),
};
